export default __webpack_public_path__ + "static/media/luxury-concierge-banner.3250a114.png";